import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import PageHeader from '../PageHeader/PageHeader';

const EventDetails = () => {
    const location = useLocation()
    const { state } = location
    return (
        <>
            <PageHeader
                title="Event Details"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Events', href: '/events' },
                    { label: state?.title }
                ]}
            />

            <div className="container pb-5 pt-5" >
                <h2 className="mb-5">{state?.title}</h2>

                <p className="mt-5">
                    {state?.description}
                </p>
                
                <h6 className="mt-5">
                    Event Date: {state?.eventDate}
                </h6>

                <div className="row mb-4 mt-5">
                    {
                        state?.image_urls?.map((item) => (
                            <div className="col-md-4 mb-3">
                                <div className="card">
                                    <img
                                        src={`https://api.coeupdspadelhi.in/${item}`}
                                        className="card-img-top"
                                        alt={state?.title}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>

        </>
    );
};

export default EventDetails;